import { render, staticRenderFns } from "./EditApplicationsPage.vue?vue&type=template&id=464a7e88&"
import script from "./EditApplicationsPage.vue?vue&type=script&lang=js&"
export * from "./EditApplicationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports